import { createSlice } from '@reduxjs/toolkit';
import { request } from 'modules/Api/HttpClient';
import {
  CUSTOM_TESTS_URL,
  CUSTOM_TEST_BY_ID_URL,
  CUSTOM_TEST_BY_WHITELABEL_URL,
  CUSTOM_TEST_BY_TEST_URL,
} from 'modules/Api/Routes';

const initialState = {
  loading: false,
  error: null,
  data: {
    customTests: [],
    page: 1,
    perPage: 15,
    search: '',
  },
};

const customTestsSlice = createSlice({
  name: 'customTests',
  initialState,
  reducers: {
    cleanState: () => ({ ...initialState }),
    /**
     * indicate that a request is started
     */
    requestCustomTests: (state) => {
      state.loading = true;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    /**
     * receive a success response
     */
    receiveRequestSuccess: (state) => {
      state.lading = false;
    },
    /**
     * receive a success customTests list response
     */
    receiveCustomTestsList: (state, action) => {
      state.loading = false;
      state.data = {
        ...state.data,
        customTests: action.payload?.custom_tests,
        total: action.payload?.total_items,
      };
    },
    clearCustomTestsList: (state) => {
      state.loading = false;
      state.data = {
        page: 1,
        perPage: 15,
      };
    },
    /**
     * receive an error response
     */
    receiveCustomTestsError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    changeCustomTestsPage: (state, action) => {
      state.data.page = action.payload;
    },
    changeCustomTestSearch: (state, action) => {
      state.data.search = action.payload.search;
      state.data.page = 1;
    },
  },
});

const Actions = customTestsSlice.actions;

const Selectors = {
  fetchListData: (state) => state.customTests,
  customTestLoading: ({ customTest: { loading } }) => ({ loading }),
};

const Async = {
  fetchCustomTestsList:
    ({ group_id } = {}) =>
    async (dispatch) => {
      let action;

      dispatch(Actions.requestCustomTests());

      try {
        const response = await request({
          method: 'GET',
          url: CUSTOM_TESTS_URL,
          params: {
            sort: 'ASC',
            sort_by: 'name',
            group_id,
          },
        });

        action = Actions.receiveCustomTestsList(response.data.content);
      } catch (e) {
        action = Actions.receiveCustomTestsError(e.message);
      }

      dispatch(action);
    },

  getCustomTestById:
    ({ id, onSuccess, onError }) =>
    async () => {
      try {
        const response = await request({
          method: 'GET',
          url: `${CUSTOM_TEST_BY_ID_URL}?id=${id}`,
        });

        onSuccess(response);
      } catch (e) {
        onError(e);
      }
    },

  getCustomTestByWhitelabel:
    ({ id, onSuccess, onError }) =>
    async () => {
      try {
        const response = await request({
          method: 'GET',
          url: `${CUSTOM_TEST_BY_WHITELABEL_URL}?whitelabel_id=${id}`,
        });

        onSuccess(response);
      } catch (e) {
        onError(e);
      }
    },

  getCustomTestByTestId:
    ({ id, onSuccess, onError }) =>
    async () => {
      try {
        const response = await request({
          method: 'GET',
          url: `${CUSTOM_TEST_BY_TEST_URL}?test_id=${id}`,
        });

        onSuccess(response);
      } catch (e) {
        onError(e);
      }
    },
};

const { reducer } = customTestsSlice;

export { reducer, Actions, Async, Selectors };
